import { render, staticRenderFns } from "./SubMain.vue?vue&type=template&id=976a6dbc&scoped=true"
import script from "./SubMain.vue?vue&type=script&lang=js"
export * from "./SubMain.vue?vue&type=script&lang=js"
import style0 from "./SubMain.vue?vue&type=style&index=0&id=976a6dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976a6dbc",
  null
  
)

export default component.exports